'use strict';

module.exports = function initCartRemoveProductModal() {
	$(document).on('click', '.cart-remove-modal__back', function () {
		$('#removeProductModal').modal('hide');
	});
};
